import { colorForIcon } from "@/utils/iconColors.js";

function stroke(color, overrides = {}) {
    return {
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...overrides
    };
}

function Svg({ className, children, ...rest }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            {...rest}
        >
            {children}
        </svg>
    );
}

const ICONS = {
    "arrow-left": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M19 12H5" />
                <path {...s} d="m12 19-7-7 7-7" />
            </Svg>
        );
    },
    cart: (className, color) => (
        <Svg className={className}>
            <path
                fill={color}
                d="M7 18a2 2 0 1 0 .01 4A2 2 0 0 0 7 18Zm10 0a2 2 0 1 0 .01 4A2 2 0 0 0 17 18ZM7.16 14.26l.03.01L18.7 14.2c.65 0 1.22-.36 1.52-.9l3.1-5.62A.88.88 0 0 0 22.55 6.5H5.4L4.55 4.5H1.5v1.75h2l3.12 6.59-1.17 2.12c-.4.72.12 1.64.95 1.64H20.5V14.5H7.42a.25.25 0 0 1-.24-.25l.03-.12.76-1.38Z"
            />
        </Svg>
    ),
    package: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M21 8.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8.5" />
                <path {...s} d="M12 12.5 21 7.5 12 2.5 3 7.5Z" />
                <path {...s} d="M12 12.5V22" />
                <path {...s} d="M7 5.5v6.5" />
                <path {...s} d="M17 5.5v6.5" />
            </Svg>
        );
    },
    heart: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path
                    {...s}
                    d="M20.8 6.6a4.5 4.5 0 0 0-6.4 0L12 8.9l-2.4-2.3a4.5 4.5 0 1 0-6.4 6.4L12 21.3l8.8-8.3a4.5 4.5 0 0 0 0-6.4Z"
                />
            </Svg>
        );
    },
    "heart-filled": (className, color) => (
        <Svg className={className}>
            <path
                fill={color}
                d="M20.8 6.6a4.5 4.5 0 0 0-6.4 0L12 8.9l-2.4-2.3a4.5 4.5 0 1 0-6.4 6.4L12 21.3l8.8-8.3a4.5 4.5 0 0 0 0-6.4Z"
            />
        </Svg>
    ),
    "map-pin": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11Z" />
                <circle {...s} cx="12" cy="10" r="2.5" />
            </Svg>
        );
    },
    user: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="12" cy="8" r="4" />
                <path {...s} d="M5 20a7 7 0 0 1 14 0" />
            </Svg>
        );
    },
    lock: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <rect {...s} x="5" y="11" width="14" height="10" rx="2" />
                <path {...s} d="M8 11V8a4 4 0 0 1 8 0v3" />
            </Svg>
        );
    },
    store: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M3 9 5 3h14l2 6" />
                <path {...s} d="M3 9h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9Z" />
                <path {...s} d="M9 21V12h6v9" />
            </Svg>
        );
    },
    mail: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <rect {...s} x="3" y="5" width="18" height="14" rx="2" />
                <path {...s} d="m3 7 9 6 9-6" />
            </Svg>
        );
    },
    "clipboard-list": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <rect {...s} x="8" y="3" width="12" height="16" rx="2" />
                <path {...s} d="M10 3.5V2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5" />
                <path {...s} d="M12 11h6" />
                <path {...s} d="M12 15h6" />
                <path {...s} d="M12 19h4" />
                <path {...s} d="M4 8h3" />
                <path {...s} d="M4 12h3" />
                <path {...s} d="M4 16h3" />
            </Svg>
        );
    },
    box: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 22 3 17V7l9-5 9 5v10Z" />
                <path {...s} d="M12 22V12" />
                <path {...s} d="m3 7 9 5 9-5" />
            </Svg>
        );
    },
    layers: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="m12 2 9 5-9 5-9-5 9-5Z" />
                <path {...s} d="m3 12 9 5 9-5" />
                <path {...s} d="m3 17 9 5 9-5" />
            </Svg>
        );
    },
    users: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="9" cy="8" r="3.5" />
                <path {...s} d="M2.5 20a6.5 6.5 0 0 1 13 0" />
                <circle {...s} cx="17.5" cy="9" r="2.5" />
                <path {...s} d="M15 20a5 5 0 0 1 7.5-4.3" />
            </Svg>
        );
    },
    star: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path
                    {...s}
                    d="m12 3.2 2.4 5.5 6 .5-4.6 4 1.4 5.9L12 16.8 6.8 19.1l1.4-5.9-4.6-4 6-.5Z"
                />
            </Svg>
        );
    },
    truck: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M10 17h4V5H2v12h3" />
                <path {...s} d="M14 9h4l3 3v5h-2" />
                <circle {...s} cx="7.5" cy="17.5" r="2.5" />
                <circle {...s} cx="17.5" cy="17.5" r="2.5" />
            </Svg>
        );
    },
    sparkles: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 3v3" />
                <path {...s} d="M12 18v3" />
                <path {...s} d="M3 12h3" />
                <path {...s} d="M18 12h3" />
                <path {...s} d="m5.6 5.6 2.1 2.1" />
                <path {...s} d="m16.3 16.3 2.1 2.1" />
                <path {...s} d="m16.3 5.6-2.1 2.1" />
                <path {...s} d="m5.6 16.3 2.1-2.1" />
                <path
                    {...s}
                    d="m12 8.2 1.1 2.5 2.7.2-2.1 1.8.6 2.6L12 14.1l-2.3 1.2.6-2.6-2.1-1.8 2.7-.2Z"
                />
            </Svg>
        );
    },
    "file-text": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
                <path {...s} d="M14 2v6h6" />
                <path {...s} d="M9 13h6" />
                <path {...s} d="M9 17h6" />
                <path {...s} d="M9 9h2" />
            </Svg>
        );
    },
    eye: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                <circle {...s} cx="12" cy="12" r="2.5" />
            </Svg>
        );
    },
    "eye-off": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M10.7 10.7A2.5 2.5 0 0 0 12 15a2.5 2.5 0 0 0 2.3-1.5" />
                <path {...s} d="M6.7 6.8C4.1 8.5 2.4 12 2.4 12s3.5 7 9.6 7c1.5 0 2.9-.4 4.1-1" />
                <path {...s} d="M17.3 17.2C19.9 15.5 21.6 12 21.6 12s-3.5-7-9.6-7c-1 0-1.9.2-2.8.5" />
                <path {...s} d="m3 3 18 18" />
            </Svg>
        );
    },
    pencil: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 20h9" />
                <path {...s} d="M16.5 4.5a2.1 2.1 0 0 1 3 3L8 19l-4 1 1-4Z" />
            </Svg>
        );
    },
    trash: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M3 6h18" />
                <path {...s} d="M8 6V4h8v2" />
                <path {...s} d="M6 6l1 14h10l1-14" />
                <path {...s} d="M10 10v6" />
                <path {...s} d="M14 10v6" />
            </Svg>
        );
    },
    download: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 3v12" />
                <path {...s} d="m7 10 5 5 5-5" />
                <path {...s} d="M5 21h14" />
            </Svg>
        );
    },
    "log-in": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <path {...s} d="m10 17 5-5-5-5" />
                <path {...s} d="M15 12H3" />
            </Svg>
        );
    },
    "log-out": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <path {...s} d="m16 17 5-5-5-5" />
                <path {...s} d="M21 12H9" />
            </Svg>
        );
    },
    "user-plus": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="9" cy="8" r="3.5" />
                <path {...s} d="M3 20a6 6 0 0 1 12 0" />
                <path {...s} d="M19 8v6" />
                <path {...s} d="M16 11h6" />
            </Svg>
        );
    },
    share: (className, color) => {
        // iOS-style curved forward / share arrow (arrowshape.turn.up.right)
        return (
            <Svg className={className}>
                <path
                    fill="none"
                    stroke={color}
                    strokeWidth="1.75"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    d="M4.5 19.5C4.5 12.5 10 7.5 17 7.5h1V4.5L22.5 10 18 15.5v-3h-1c-5 0-8.8 2.8-9.8 7H4.5z"
                />
            </Svg>
        );
    },
    upload: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="M12 16V4" />
                <path {...s} d="m7 9 5-5 5 5" />
                <path {...s} d="M5 20h14" />
            </Svg>
        );
    },
    "x-circle": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="12" cy="12" r="9" />
                <path {...s} d="m9 9 6 6" />
                <path {...s} d="m15 9-6 6" />
            </Svg>
        );
    },
    x: (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <path {...s} d="m6 6 12 12" />
                <path {...s} d="m18 6-12 12" />
            </Svg>
        );
    },
    "user-check": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="9" cy="8" r="3.5" />
                <path {...s} d="M3 20a6 6 0 0 1 12 0" />
                <path {...s} d="m17 11 2 2 4-4" />
            </Svg>
        );
    },
    "user-minus": (className, color) => {
        const s = stroke(color);
        return (
            <Svg className={className}>
                <circle {...s} cx="9" cy="8" r="3.5" />
                <path {...s} d="M3 20a6 6 0 0 1 12 0" />
                <path {...s} d="M16 11h6" />
            </Svg>
        );
    }
};

export const ICON_NAMES = Object.keys(ICONS);

/**
 * @param {{ name: string, className?: string, color?: string, active?: boolean, danger?: boolean }} props
 */
export default function Icon({ name, className = "", color, active = false, danger = false }) {
    const render = ICONS[name];
    if (!render) {
        return null;
    }
    const resolvedColor = color ?? colorForIcon(name, { active, danger });
    return render(className, resolvedColor);
}
